export const iconMaps = {
  "sprite_exp_card_t1": require('../../assets/icons/sprite_exp_card_t1.png'),
  "sprite_exp_card_t2": require('../../assets/icons/sprite_exp_card_t2.png'),
  "sprite_exp_card_t3": require('../../assets/icons/sprite_exp_card_t3.png'),
  "sprite_exp_card_t4": require('../../assets/icons/sprite_exp_card_t4.png'),
  "MTL_GOLD3": require('../../assets/icons/MTL_GOLD3.png'),
  "MTL_BASE_SL1": require('../../assets/icons/MTL_BASE_SL1.png'),
  "MTL_BASE_SL2": require('../../assets/icons/MTL_BASE_SL2.png'),
  "MTL_BASE_SL3": require('../../assets/icons/MTL_BASE_SL3.png'),
  "MTL_BASE_SYNTH1": require('../../assets/icons/MTL_BASE_SYNTH1.png'),
  "MTL_BASE_SYNTH2": require('../../assets/icons/MTL_BASE_SYNTH2.png'),
  "MTL_BASE_SYNTH3": require('../../assets/icons/MTL_BASE_SYNTH3.png'),
  "MTL_ASC_PIO1": require('../../assets/icons/MTL_ASC_PIO1.png'),
  "MTL_ASC_PIO2": require('../../assets/icons/MTL_ASC_PIO2.png'),
  "MTL_ASC_PIO3": require('../../assets/icons/MTL_ASC_PIO3.png'),
  "MTL_ASC_GRD1": require('../../assets/icons/MTL_ASC_GRD1.png'),
  "MTL_ASC_GRD2": require('../../assets/icons/MTL_ASC_GRD2.png'),
  "MTL_ASC_GRD3": require('../../assets/icons/MTL_ASC_GRD3.png'),
  "MTL_ASC_TNK1": require('../../assets/icons/MTL_ASC_TNK1.png'),
  "MTL_ASC_TNK2": require('../../assets/icons/MTL_ASC_TNK2.png'),
  "MTL_ASC_TNK3": require('../../assets/icons/MTL_ASC_TNK3.png'),
  "MTL_ASC_SNP1": require('../../assets/icons/MTL_ASC_SNP1.png'),
  "MTL_ASC_SNP2": require('../../assets/icons/MTL_ASC_SNP2.png'),
  "MTL_ASC_SNP3": require('../../assets/icons/MTL_ASC_SNP3.png'),
  "MTL_ASC_CST1": require('../../assets/icons/MTL_ASC_CST1.png'),
  "MTL_ASC_CST2": require('../../assets/icons/MTL_ASC_CST2.png'),
  "MTL_ASC_CST3": require('../../assets/icons/MTL_ASC_CST3.png'),
  "MTL_ASC_MED1": require('../../assets/icons/MTL_ASC_MED1.png'),
  "MTL_ASC_MED2": require('../../assets/icons/MTL_ASC_MED2.png'),
  "MTL_ASC_MED3": require('../../assets/icons/MTL_ASC_MED3.png'),
  "MTL_ASC_SUP1": require('../../assets/icons/MTL_ASC_SUP1.png'),
  "MTL_ASC_SUP2": require('../../assets/icons/MTL_ASC_SUP2.png'),
  "MTL_ASC_SUP3": require('../../assets/icons/MTL_ASC_SUP3.png'),
  "MTL_ASC_SPC1": require('../../assets/icons/MTL_ASC_SPC1.png'),
  "MTL_ASC_SPC2": require('../../assets/icons/MTL_ASC_SPC2.png'),
  "MTL_ASC_SPC3": require('../../assets/icons/MTL_ASC_SPC3.png'),
  "MTL_SKILL1": require('../../assets/icons/MTL_SKILL1.png'),
  "MTL_SKILL2": require('../../assets/icons/MTL_SKILL2.png'),
  "MTL_SKILL3": require('../../assets/icons/MTL_SKILL3.png'),
  "GOLD": require('../../assets/icons/GOLD.png'),
  "MTL_SL_G1": require('../../assets/icons/MTL_SL_G1.png'),
  "MTL_SL_G2": require('../../assets/icons/MTL_SL_G2.png'),
  "MTL_SL_G3": require('../../assets/icons/MTL_SL_G3.png'),
  "MTL_SL_G4": require('../../assets/icons/MTL_SL_G4.png'),
  "MTL_SL_STRG1": require('../../assets/icons/MTL_SL_STRG1.png'),
  "MTL_SL_STRG2": require('../../assets/icons/MTL_SL_STRG2.png'),
  "MTL_SL_STRG3": require('../../assets/icons/MTL_SL_STRG3.png'),
  "MTL_SL_STRG4": require('../../assets/icons/MTL_SL_STRG4.png'),
  "MTL_SL_RUSH1": require('../../assets/icons/MTL_SL_RUSH1.png'),
  "MTL_SL_RUSH2": require('../../assets/icons/MTL_SL_RUSH2.png'),
  "MTL_SL_RUSH3": require('../../assets/icons/MTL_SL_RUSH3.png'),
  "MTL_SL_RUSH4": require('../../assets/icons/MTL_SL_RUSH4.png'),
  "MTL_SL_IRON1": require('../../assets/icons/MTL_SL_IRON1.png'),
  "MTL_SL_IRON2": require('../../assets/icons/MTL_SL_IRON2.png'),
  "MTL_SL_IRON3": require('../../assets/icons/MTL_SL_IRON3.png'),
  "MTL_SL_IRON4": require('../../assets/icons/MTL_SL_IRON4.png'),
  "MTL_SL_KETONE1": require('../../assets/icons/MTL_SL_KETONE1.png'),
  "MTL_SL_KETONE2": require('../../assets/icons/MTL_SL_KETONE2.png'),
  "MTL_SL_KETONE3": require('../../assets/icons/MTL_SL_KETONE3.png'),
  "MTL_SL_KETONE4": require('../../assets/icons/MTL_SL_KETONE4.png'),
  "MTL_SL_BOSS1": require('../../assets/icons/MTL_SL_BOSS1.png'),
  "MTL_SL_BOSS2": require('../../assets/icons/MTL_SL_BOSS2.png'),
  "MTL_SL_BOSS3": require('../../assets/icons/MTL_SL_BOSS3.png'),
  "MTL_SL_BOSS4": require('../../assets/icons/MTL_SL_BOSS4.png'),
  "MTL_SL_ALCOHOL1": require('../../assets/icons/MTL_SL_ALCOHOL1.png'),
  "MTL_SL_ALCOHOL2": require('../../assets/icons/MTL_SL_ALCOHOL2.png'),
  "MTL_SL_MANGANESE1": require('../../assets/icons/MTL_SL_MANGANESE1.png'),
  "MTL_SL_MANGANESE2": require('../../assets/icons/MTL_SL_MANGANESE2.png'),
  "MTL_SL_PG1": require('../../assets/icons/MTL_SL_PG1.png'),
  "MTL_SL_PG2": require('../../assets/icons/MTL_SL_PG2.png'),
  "MTL_SL_RMA7012": require('../../assets/icons/MTL_SL_RMA7012.png'),
  "MTL_SL_RMA7024": require('../../assets/icons/MTL_SL_RMA7024.png'),
  "MTL_SL_PP": require('../../assets/icons/MTL_SL_PP.png'),
  "MTL_SL_BN": require('../../assets/icons/MTL_SL_BN.png'),
  "MTL_SL_DS": require('../../assets/icons/MTL_SL_DS.png'),
  // "MTL_SL_PGEL3": require('../../assets/icons/MTL_SL_PGEL3.png'),
  // "MTL_SL_PGEL4": require('../../assets/icons/MTL_SL_PGEL4.png'),
  // "MTL_SL_IAM3": require('../../assets/icons/MTL_SL_IAM3.png'),
  // "MTL_SL_IAM4": require('../../assets/icons/MTL_SL_IAM4.png'),
  // "MTL_ASC_DI": require('../../assets/icons/MTL_ASC_DI.png'),
  // "ap_supply_lt_10": require('../../assets/icons/ap_supply_lt_10.png'),
  // "voucher_item_4pick1": require('../../assets/icons/voucher_item_4pick1.png'),
  // "voucher_recruitR3_1": require('../../assets/icons/voucher_recruitR3_1.png'),
  // "voucher_recruitR4_1": require('../../assets/icons/voucher_recruitR4_1.png'),
  // "2020recruitment10_1": require('../../assets/icons/2020recruitment10_1.png'),
  // "2020recruitment10_2": require('../../assets/icons/2020recruitment10_2.png'),
  // "2020recruitment10_3": require('../../assets/icons/2020recruitment10_3.png'),
  // "randomMaterial_1": require('../../assets/icons/randomMaterial_1.png')
}